import _axios from '@/util/httpConfig.js'

// 联系方式 RESE3253BF4674F7CE
// 了解我们 RES9073F768BFCE5CF
export const getStep = (contentCode) => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}

/**
 *
 * {appCode: "APPAFBB8CD316AFF62", moduleName: "", pageNo: 0, pageSize: 1000,…}
 * appCode: "APPAFBB8CD316AFF62"
 * moduleName: ""
 * pageNo: 0
 * pageSize: 1000
 * parentResourceCode: "RESB85E3E92C042D49"
 * resourceName: ""
 * status: "E"
 * tenantCode: "96F307B9D0EDF9F"
 */


export const getModuleInfo = (parentResourceCode) => { //获取二级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "moduleName": "",
    "pageNo": 0,
    "pageSize": 1000,
    "parentResourceCode": parentResourceCode,
    "resourceName": "",
    "status": "E",
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}

export const getModuleChild = (moduleCode, contentType) => {  //获取三级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 10,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', `/common-content/${contentType}/list`, '', data)
}



export const getInfo = (contentCode) => {  //企业服务  三级
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}


// 获取人事代理项目 TYPE_9EE0B8CBD0F379A   RESFA0CCB3FF6CDB80
// 劳务派遣事项 TYPE_6F7AB9A126EF075 RESFA0CCB3FF6CDB80
// 表格下载 RES22D560EF174EDA7
// 其他 RES93CDDCB0AAC2FEB
// 公积金 RESE3584DAC7A49E11
// 医保 RESCF5A69E855E638C
// 社保 RESC522AC0AC50AB33
// 福利定制 RESB17CBEDE86CCA0D
// 外籍服务 RES0BAEB036C77135A
// 业务外包 RESBDAD7868DE3B1D8
// 人事管理 RESFA0CCB3FF6CDB80
// 服务指南 RES7647CE3C708E3B8
// 外企风采 RES6D2912437254887
// 人事招聘 RES02919AC81B5C71C
// 合作伙伴 RES3AB1EB4E66BBD25
// 服务客户 RES4FC5BF32B989502


export const getStaff = () => {  //获取员工服务 一级
  const data = {
    appCode: "APPAFBB8CD316AFF62",
    moduleName: "",
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RESB85E3E92C042D49",
    resourceName: "",
    status: "E",
    tenantCode: "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}


export const getList = (moduleCode) => {   //获取员工服务 一级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 6,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ''
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}

export const getPic = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 100,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentPic/list', '', data)
}

export const getDetail = (picCode) => {
  return _axios('GET', `common-content/contentPic/get?picCode=${picCode}&tenantCode=96F307B9D0EDF9F`)
}

//获取信息咨讯
export const getInforTitle = () => {  
  const data = {
    appCode: "APPAFBB8CD316AFF62",
    moduleName: "",
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RES16D24EA2892BBC4",
    resourceName: "",
    status: "E",
    tenantCode: "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}

export const getText = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 0,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}



// WEBPACK FOOTER //
// ./src/api/foreignCompanyService.js